<template>
    
  <div class="mod-sys__slcustomer}">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">

      
      <el-form-item>
        <el-input v-model="dataForm.brokerName" placeholder="经纪人姓名" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="dataForm.brokerMobile" placeholder="经纪人手机号" clearable></el-input>
      </el-form-item>
    
      <el-form-item>
        <el-button @click="getDataList()">{{ $t('query') }}</el-button>
      </el-form-item>
      
      <!-- <el-form-item>
        <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="$hasPermission('sys:slcustomer:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="$hasPermission('sys:slcustomer:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
      </el-form-item> -->
    </el-form>
    <el-table v-loading="dataListLoading" :data="dataList" border  style="width: 100%;">
      <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
      <el-table-column prop="brokerName" label="经纪人姓名" header-align="center" align="center"></el-table-column>
      <el-table-column prop="brokerMobile" label="手机号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="bankNo" label="银行卡" header-align="center" align="center"></el-table-column>
      <el-table-column prop="amount" label="申请金额" header-align="center" align="center"></el-table-column>
      <el-table-column prop="createDate"  label="申请时间" header-align="center" align="center">
       
      </el-table-column>
      <el-table-column prop="status"  label="提现状态" header-align="center" align="center">
        <template slot-scope="scope">
          <el-select v-if="scope.row.myishsow" v-model="scope.row.status"  filterable clearable  placeholder="类型">
                  <el-option
                          v-for="item in statusList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
            </el-select>
            <div v-else> {{ geteducation(scope.row.status,'status') }} </div>
          
        </template>
      </el-table-column>
      <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button  type="text" size="small" @click="submitStatus(scope.row)">{{ scope.row.myishsow ? '完成' : '修改' }}</el-button>
            <!-- <el-button v-if="$hasPermission('sys:slcustomer:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">完成</el-button> -->
          </template>
        </el-table-column>
     
    </el-table>
    <el-pagination
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="limit"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="pageCurrentChangeHandle">
    </el-pagination>
  
  </div>

</template>

<script>
import mixinViewModule from '@/mixins/view-module'
export default {
mixins: [mixinViewModule],
data () {
  return {
    mixinViewModuleOptions: {
      getDataListURL: '/sys/slaccountcash/page',
      getDataListIsPage: true,
      exportURL: '/sys/slaccountcash/export',
      deleteURL: '/sys/slaccountcash',
      deleteIsBatch: true
    },
 
    date: '',
    userTypes: [],
    statusList: [
      {
      label: '已申请提现',
      value: '0',
    },
    {
      label: '已打款',
      value: '1',
    },
  ],
    dataForm: {
      brokerNam: '',
      brokerMobile: '',
      status: '0',
      }
  }
},
created(){
  this.getuserTypeOptions()
},

methods: {
  //修改状态
  submitStatus(row){
    // console.log(this.dataList.findIndex(item => item.id == row.id))
    let n = this.dataList.findIndex(item => item.id == row.id)
    this.$set(this.dataList,n,{...this.dataList[n],myishsow: !this.dataList[n].myishsow})
    if(row.myishsow){
        let obj = {
          id: row.id,
          status: row.status,
          verifyTime: this.getTime(),
        }

        this.$http.put('/sys/slaccountcash', obj ).then(({ data: res }) => {
          if (res.code !== 0) {
            this.query()
            this.$message.error(res.msg)
            return
          }
            this.$message.success(res.msg)
            this.query()
            return
          }) 
      }
  },
    //利⽤change事件监听表单内容变化，并将选中的值赋值给所需要的两个字段
  //⽀付时间戳设置
  getTimes() {
    if (this.date != null) {
      this.dataForm.start = this.date[0]
      this.dataForm.end = this.date[1]
    }else{
      delete this.dataForm.startDate 
          delete this.dataForm.endDate
    }
  },
  getTime(){
    const now = new Date();
    const year = now.getFullYear();        // 获取当前年份，例如 2023
    const month = now.getMonth() + 1;      // 获取当前月份，注意返回值范围是 0~11，需要加上 1
    const day = now.getDate();             // 获取当前日期，例如 14
    const hour = now.getHours();           // 获取当前小时数，例如 9
    const minute = now.getMinutes();       // 获取当前分钟数，例如 30
    const second = now.getSeconds();       // 获取当前秒数，例如 15
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`

  },
  geteducation(v,name){
    if(name == 'userType')  return this.userTypes.filter(item => item.value == v)[0]?.label ;
    if(name == 'education') return this.educations.filter(item => item.value == v)[0]?.label ;
    if(name == 'vipLevelId') return this.vipLevels.filter(item => item.value == v)[0]?.label ;
    if(name == 'maritalStatus') return this.maritalStatus.filter(item => item.value == v)[0]?.label ;
    if(name == 'isAuth') return this.isAuth.filter(item => item.value == v)[0]?.label ;
    if(name == 'status') return this.statusList.filter(item => item.value == v)[0]?.label ;
  },
     //初始用户类型名称下拉框中的选项
     async getuserTypeOptions() {
         this.$http.get(`/sys/dict/data/list?dataType=userType`).then(({ data: res }) => {
            if (res.code !== 0) {
                return this.$message.error(res.msg)
            }
            this.userTypes = [];
            if (res.data!=null){
                res.data.forEach(element => {
                    this.userTypes.push({label:element.dictLabel,value:element.dictValue})
                })
            }
        }).catch(() => {})
    },

},
components: {
  // AddOrUpdate
}
}
</script>
